// Latest Thoughts feed (mockup #2). Prefers REAL thoughts (moments + recent
// observations via selectLatestThoughts); falls back to MOCK prose only when there is
// nothing real to say (marked with *).
import React from "react";
import { MOCK_LATEST_THOUGHTS } from "../mock/mockData";

const KIND_DOT = { supersede: "bg-sky-400", confidence: "bg-emerald-400", conflict: "bg-amber-400", observation: "bg-cyan-400", mock: "bg-slate-600" };

export default function LatestThoughts({ thoughts }) {
  const real = Array.isArray(thoughts) ? thoughts : [];
  const usingMock = real.length === 0;
  const rows = usingMock ? MOCK_LATEST_THOUGHTS.map((t) => ({ kind: "mock", text: t })) : real;

  return (
    <div data-testid="latest-thoughts" className="rounded-xl border border-slate-800 bg-slate-900/60 p-4">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-slate-200">Latest Thoughts</h3>
        {usingMock ? <span className="text-[10px] text-slate-600" title="MOCK placeholder — no real moments/observations yet">placeholder *</span> : <span className="text-[10px] text-emerald-500/70">live</span>}
      </div>
      <ul className="space-y-2">
        {rows.map((t, i) => (
          <li key={i} className="flex items-start gap-2" data-testid="thought-row">
            <span className={`mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full ${KIND_DOT[t.kind] || "bg-slate-600"}`} aria-hidden="true" />
            <p className="text-sm text-slate-300">{t.text}{t.kind === "mock" ? <span className="ml-0.5 text-[8px] align-super text-slate-600">*</span> : null}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
